
<div mat-dialog-title>Import Assigned Account's Holdings
  <button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear" >clear</i></button>
  @if (!isAltWorkflow) {
    <span class="stepsProgressIndicator">Step 3 of 4</span>
  }
</div>
<mat-dialog-content>
  @if (portfolioName) {
    <div class="nameHeader">Portfolio: {{portfolioName}}</div>
  }
  <div>
    <div class="nameHeader">Assigned Accounts</div>
    <div class="block">@if (!isUiTest) {
      <irb-inventory-grid
        [style.width] = "'100%'"
        [style.height] = "'140px'"
        [showSideBar] = "false"
        [gridOptions] = "portfolioAccountsGridOptions"
        [frameworkComponents] = 'portfolioAccountsGridOptions.frameworkComponents'
        [rowData] = 'portfolioAccounts'
      (gridReady) = "onPortfolioAccountsGridReady($event)"></irb-inventory-grid>
    }</div>
    @if (data && data.length > 0) {
      <div>The combined holdings of the accounts you assigned are listed below.<br/>You can select which ones to import into the security master, or assign them to a custom category.<br/><strong>Note:</strong> Account sweeps will not be listed here and cannot be added to the security master.</div>
    }
    @if (data && data.length == 0) {
      <div>The account(s) which you are assigning do not contain any iRebal eligible positions (the account(s) might contain only cash)</div>
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button id="closeButton" (click)="close()" class="btn-medium-secondary">Cancel</button>
  <button class="btn-medium-primary" (click)="callFinishButtonCallback()">{{finishButtonLabel}}</button>
</mat-dialog-actions>
